import {
  AssetViz,
  AssetVizHeatmapDisplayState,
  AssetVizMode,
} from 'features/assetViz'
import React, { FC } from 'react'
import { GeckoAssetModel, GeckoComponent, GeckoComponentDataFrame } from 'types'

export const SiteViewAssetVizWrapper: FC<{
  selectedAssetModel: GeckoAssetModel
  selectedComponent: GeckoComponent
  selectedCDF: GeckoComponentDataFrame
}> = ({ selectedAssetModel, selectedComponent, selectedCDF }) => {
  const sceneConfig = {
    show3D: true,
    heatmapDisplayState: AssetVizHeatmapDisplayState.Sharp,
    showFeatures: true,
    heatmapOpacity: 1,
  }

  return (
    <AssetViz
      components={selectedComponent ? [selectedComponent] : []}
      colorThreshold={undefined}
      componentDataFrames={[selectedCDF]}
      assetModel={selectedAssetModel}
      sceneConfig={sceneConfig}
      mode={AssetVizMode.SelectBin}></AssetViz>
  )
}
